import { useState } from "react";

const getAvailableGranularities = (isWindow, isPeriodOverPeriod) => ({
    daily: {
        title: "D",
        disabled: isPeriodOverPeriod(),
        value: "Daily",
        index: 0,
    },
    weekly: {
        title: "W",
        disabled: isPeriodOverPeriod(),
        value: "Weekly",
        index: 1,
    },
    monthly: { title: "M", disabled: isWindow(), value: "Monthly", index: 2 },
});
export const useGranularities = ({
    isWindow,
    isPeriodOverPeriod,
    periodDuration,
    urlGranularityParam,
    updateUrlParam,
}) => {
    const { daily, weekly, monthly } = getAvailableGranularities(isWindow, isPeriodOverPeriod);
    const availableGranularities = [daily, weekly, monthly];

    function resetSelectedGranularity() {
        if (isPeriodOverPeriod()) {
            return monthly;
        }
        if (isWindow()) {
            return daily;
        }
        if (periodDuration <= 2) {
            return weekly;
        }
        return monthly;
    }

    const [selectedGranularity, setGranularity] = useState(resetSelectedGranularity());
    const chosenAvailableGranularity = availableGranularities.find(({ value }) => value === selectedGranularity.value);
    if (chosenAvailableGranularity.disabled) {
        setGranularity(resetSelectedGranularity());
    }
    const updateGranularity = (val) => setGranularity(availableGranularities.find(({ value }) => value === val));
    if (urlGranularityParam && urlGranularityParam !== selectedGranularity.value) {
        const granularityFromParam = availableGranularities.find(({ value }) => value === urlGranularityParam);
        if (granularityFromParam.disabled) {
            updateUrlParam(resetSelectedGranularity());
        } else {
            setGranularity(granularityFromParam);
        }
    }
    return { selectedGranularity, availableGranularities, updateGranularity };
};
const mtdSession = {
    cacheValue: null,
    ttl: null,
};
export const useMTD = ({ isWindow, disableMTD, isPeriodOverPeriod, durationObject, component, urlMtdParam }) => {
    function isMTDSupported() {
        if (isWindow() || disableMTD || isPeriodOverPeriod()) {
            return false;
        }
        const to = durationObject.raw.to.valueOf();
        const componentEndDate = component.endDate.valueOf();
        return to === componentEndDate;
    }
    function loadInitialMTDValue() {
        const openByDefault = true;
        if (!isMTDSupported()) {
            return false;
        }
        if (urlMtdParam != null) {
            return urlMtdParam;
        }
        if (mtdSession.ttl && Date.now() - mtdSession.ttl <= 1000 * 60 * 30) {
            return mtdSession.cacheValue;
        }
        return openByDefault;
    }
    const [isMTDOn, setMTD] = useState(() => loadInitialMTDValue());
    const isMTDActive = () => isMTDOn && isMTDSupported();
    if (isMTDOn && !isMTDSupported()) {
        setMTD(false);
    }
    return {
        isMTDActive: isMTDActive(),
        isMTDSupported: isMTDSupported(),
        setMTD: () => {
            mtdSession.cacheValue = !isMTDOn;
            mtdSession.ttl = Date.now();
            setMTD(mtdSession.cacheValue);
        },
    };
};
